import {
	CONTENT_TYPE
} from '../constact'

const defaultState = {
	contentIdMap: {},
	contentNameMap: {},
	contentType: []
}
export function addContentType(data) {
	return {
		type: CONTENT_TYPE,
		data
	}
}
const contentType = (state = defaultState, action) => {
	if(action.type === CONTENT_TYPE) {
		const newState = Object.assign({}, state)
		const nameMap = {}
		const idMap = {}
		action.data.forEach((item: any) => {
			nameMap[item.name] = item.id
			idMap[item.id]= item.name
		})
		newState.contentIdMap = idMap
		newState.contentNameMap = nameMap
		newState.contentType = action.data
		return newState
	}
	return state
}
export default contentType